export const CATEGORY_PATH = {
  agricultural: "/agricultural-land",
  plot: "/plots",
  apartment: "/homes",
  villa: "/homes",
  commercial: "/commercial",
};

export const CATEGORY_LABEL = {
  agricultural: "Agricultural Land",
  plot: "Open Plots",
  apartment: "Homes",
  villa: "Homes",
  commercial: "Commercial",
};

export const LANDINGS = {
  "agricultural-land": {
    preset: { property_type: "agricultural" },
    seo: {
      title: "Agricultural Land for Sale in Telangana & Near Hyderabad | Dotlands Realty",
      description:
        "Find verified agricultural land and farmland for sale in Telangana, including locations near Hyderabad. Explore property details, locations and investment opportunities with Dotlands Realty.",
      h1: "Agricultural Land for Sale in Telangana",
      path: "/agricultural-land",
    },
  },
  plots: {
    preset: { property_type: "plot" },
    seo: {
      title: "Open Plots for Sale Near Hyderabad & Telangana | Dotlands Realty",
      description:
        "Discover residential and investment plots for sale near Hyderabad and across Telangana. Explore verified plot listings, locations, sizes and prices with Dotlands Realty.",
      h1: "Premium Plots for Sale Near Hyderabad",
      path: "/plots",
    },
  },
  homes: {
    preset: { property_type: "homes" },
    seo: {
      title: "Houses & Homes for Sale Near Hyderabad, Telangana | Dotlands Realty",
      description:
        "Discover houses and homes for sale near Hyderabad and across Telangana. Browse property details, locations, prices and features with Dotlands Realty.",
      h1: "Homes & Houses for Sale in Telangana",
      path: "/homes",
    },
  },
  commercial: {
    preset: { property_type: "commercial" },
    seo: {
      title: "Commercial Properties for Sale in Telangana | Dotlands Realty",
      description:
        "Explore commercial properties and investment opportunities in Telangana and near Hyderabad. Find suitable commercial property listings with Dotlands Realty.",
      h1: "Commercial Properties for Sale in Telangana",
      path: "/commercial",
    },
  },
  hyderabad: {
    preset: { city: "Hyderabad" },
    seo: {
      title: "Land & Plots for Sale Near Hyderabad, Telangana | Dotlands Realty",
      description:
        "Explore agricultural land, residential plots and investment properties near Hyderabad, Telangana. Browse verified listings and find properties suited to your budget.",
      h1: "Land & Plots for Sale Near Hyderabad",
      path: "/hyderabad",
    },
  },
  kadthal: {
    preset: { locality: "Kadthal" },
    seo: {
      title: "Land & Plots for Sale in Kadthal, Telangana | Dotlands Realty",
      description:
        "Explore agricultural land and plots for sale in Kadthal, Telangana. View property locations, sizes, prices and investment opportunities from Dotlands Realty.",
      h1: "Agricultural Land & Plots for Sale in Kadthal",
      path: "/kadthal",
    },
  },
  shadnagar: {
    preset: { locality: "Shadnagar" },
    seo: {
      title: "Land & Plots for Sale in Shadnagar | Agricultural Land | Dotlands Realty",
      description:
        "Find agricultural land, residential plots and investment properties for sale in Shadnagar, Telangana. Explore verified property listings with Dotlands Realty.",
      h1: "Land & Plots for Sale in Shadnagar",
      path: "/shadnagar",
    },
  },
};

export const TYPE_SEO = {
  agricultural: LANDINGS["agricultural-land"].seo,
  plot: LANDINGS.plots.seo,
  homes: LANDINGS.homes.seo,
  commercial: LANDINGS.commercial.seo,
};

export const DEFAULT_LISTING_SEO = {
  title: "Properties for Sale in Telangana — Agricultural Land, Plots & Homes | Dotlands Realty",
  description:
    "Browse verified agricultural land, farm land, open plots, residential plots and commercial properties for sale in Hyderabad and Telangana. Filter by facing, extent and DTCP/HMDA approval.",
  h1: "Properties for Sale in Telangana",
  path: "/properties",
};
